export const accessTokenLocalStorageKey = 'accessToken'
export const userIdLocalStorageKey = 'userId'

export const connectorLocalStorageKey = 'connectorId'
export const walletLocalStorageKey = 'wallet'
export const walletConnectLocalStorageKey = 'walletconnect'

export const initialWalletLoginLocalStorageKey = 'initialWalletLogin'
export const initialConnectorIdLocalStorageKey = 'initialConnectorId'
